import { render, staticRenderFns } from "./MenuCrud.vue?vue&type=template&id=3c7d0b41&"
import script from "./MenuCrud.vue?vue&type=script&lang=js&"
export * from "./MenuCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports